/* eslint-disable react/prop-types -- layout props come from RBFLMSLayout */
import HeaderAccountDropdown from "@/components/Layout/HeaderAccountDropdown";

const SEPARATOR = "#E8E8E8";

export default function Header({ loanUUID, loanSummary }) {
  return (
    <header className="bg-white border-bottom px-4 py-3" style={{ borderColor: SEPARATOR }}>
      <div className="d-flex align-items-center justify-content-between gap-3">
        {/* <div className="d-flex align-items-center gap-1">
          <button
            type="button"
            className="btn btn-link text-secondary p-2 rounded-circle"
            aria-label="Language or region"
          >
            <AppIcon name="Globe" size={20} />
          </button>
          <button type="button" className="btn btn-link text-secondary p-2 rounded-circle" aria-label="Notifications">
            <AppIcon name="Bell" size={20} />
          </button>
        </div> */}

        <div className="d-flex align-items-center gap-3 ms-auto">
          <HeaderAccountDropdown loanUUID={loanUUID} loanSummary={loanSummary} />
        </div>
      </div>
    </header>
  );
}
